import React, { Dispatch, SetStateAction } from "react";

import { ElementState, Preview } from "@creatomate/preview";

import { AWSLanguage, Subtitle } from "chq";

import SubtitleStyles from "./styles/SubtitleStyles";
import TranscriptionContainer from "./TranscriptionContainer";
import TranslationContainer from "./TranslationContainer";
import SubtitlesParser from "./SubtitlesParser";

interface SubtitlesContainerProps {
  subtitlesOn: boolean;
  activeLanguage?: Subtitle;
  changingLanguage: boolean;
  onLanguageChange: (subtitle: Subtitle | AWSLanguage) => void;
  preview: Preview;
  onSelectTranslation: (value: boolean) => void;
  onSetError: Dispatch<SetStateAction<string | undefined>>;
  showLanguageOptions: boolean;
  subtitleElements: ElementState[];
  showStyles: boolean;
}

const SubtitlesContainer: React.FC<SubtitlesContainerProps> = ({
  subtitlesOn,
  activeLanguage,
  changingLanguage,
  onLanguageChange,
  preview,
  onSelectTranslation,
  onSetError,
  showLanguageOptions,
  subtitleElements,
  showStyles
}) => {
  if (showStyles) {
    return (
      <SubtitleStyles
        activeLanguage={activeLanguage}
        onLanguageChange={onLanguageChange}
        preview={preview}
        subtitleElements={subtitleElements}
      />
    );
  }

  if (subtitlesOn) {
    return (
      <>
        {showLanguageOptions ? (
          <TranslationContainer
            onSelectTranslation={onSelectTranslation}
            preview={preview}
          />
        ) : (
          <SubtitlesParser
            activeLanguage={activeLanguage}
            changingLanguage={changingLanguage}
            onLanguageChange={onLanguageChange}
            preview={preview}
          />
        )}
      </>
    );
  }

  return (
    <TranscriptionContainer onSetError={onSetError} onLanguageSelected={onLanguageChange} />
  );
};

export default SubtitlesContainer;
